import { IProductsBlockingTypeStatus } from "../../store/slices/products/types";
import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const createProductRoute = () =>
  buildUrl({
    url: [baseUrl, "services-api", "services"].join("/"),
  });

export const fetchProductByIdRoute = ({
  onDate,
  productId,
}: {
  productId: string;
  onDate: string;
}) =>
  buildUrl({
    url: [baseUrl, "services-api", "services", productId].join("/"),
    searchParams: {
      onDate,
    },
  });

export const fetchProlongOfferingRoute = (params: { id: number; onDate: string }) => {
  const { id, onDate } = params;
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering", id].join("/"),
    searchParams: {
      onDate,
    },
  });
};

export const fetchProductVersionsRoute = (id: number | string) =>
  buildUrl({
    url: [baseUrl, "services-api", "services", id, "versions"].join("/"),
  });

export const closeProductRoute = (params: { id: number; fromDate: string }) => {
  const { id, fromDate } = params;
  return buildUrl({
    url: [baseUrl, "services-api", "services", id].join("/"),
    searchParams: { fromDate },
  });
};

export const cancelProductRoute = (params: { id: number; fromDate?: string }) => {
  const { id, fromDate } = params;
  return buildUrl({
    url: [baseUrl, "services-api", "services", id, "cancel"].join("/"),
    searchParams: { fromDate },
  });
};

export const activeateProductRoute = (params: {
  id: number;
  fromDate?: string;
  status: string;
  force?: boolean;
  activationCheck?: boolean;
}) => {
  const { id, status, activationCheck, force, fromDate } = params;
  return buildUrl({
    url: [baseUrl, "services-api", "services", id, "activation"].join("/"),
    searchParams: {
      status,
      activationCheck,
      force,
      fromDate,
    },
  });
};

export const changeProductStatusRoute = (params: {
  id: number;
  fromDate?: string;
  status: string;
  force?: boolean;
  changeChildStatuses?: boolean;
  activationCheck?: boolean;
}) => {
  const { id, status, activationCheck, changeChildStatuses, force, fromDate } = params;
  return buildUrl({
    url: [baseUrl, "services-api", "services", id, "status"].join("/"),
    searchParams: { status, activationCheck, changeChildStatuses, force, fromDate },
  });
};

export const changeProductQuantityRoute = (params: {
  id: number;
  fromDate?: string;
  quantity: number;
  force: boolean;
}) => {
  const { id, quantity, fromDate, force } = params;
  return buildUrl({
    url: [baseUrl, "services-api", "services", id, "quantity"].join("/"),
    searchParams: {
      quantity,
      fromDate,
      force,
    },
  });
};

export const fetchHierarchyProductByIdRoute = ({
  onDate,
  productId,
  agreementId,
  extendedInfo,
}: {
  productId: string;
  agreementId: number;
  onDate: string;
  extendedInfo?: boolean;
}) =>
  buildUrl({
    url: [baseUrl, "services-api", "services", "hierarchy", "search"].join("/"),
    searchParams: {
      onDate,
      serviceId: productId,
      agreementId,
      extendedInfo,
    },
  });

export const changeProlognOfferingRoute = (searchParams: {
  serviceId: number;
  prolongTypeId: number;
  offeringId: number;
  activationCheck?: boolean;
}) =>
  buildUrl({
    url: [baseUrl, "services-api", "services", "prolong"].join("/"),
    searchParams,
  });

export const getProductsBlockingTypeStatusRoute = ({
  objectTypeId,
  objectId,
  onDate,
}: IProductsBlockingTypeStatus) => {
  return buildUrl({
    url: `${baseUrl}/blocking-manager-api/blocking/${objectTypeId}/${objectId}/status`,
    searchParams: { onDate },
  });
};
